export default __webpack_public_path__ + "static/media/21-min.63f3fb60.jpg";